import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const Inspiration = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  const inspirations = [
    {
      id: 1,
      title: 'Living Rooms',
      image: 'https://images.pexels.com/photos/8082311/pexels-photo-8082311.jpeg?_gl=1*rdhufc*_ga*MTEwNzAyNjQ3LjE3NzE0MDQ5OTY.*_ga_8JE65Q40S6*czE3NzE0OTEwMjckbzMkZzEkdDE3NzE0OTIzNjgkajIyJGwwJGgw',
      span: 'col-span-1 row-span-1',
    },
    {
      id: 2,
      title: 'Bathrooms',
      image: 'https://images.pexels.com/photos/6058447/pexels-photo-6058447.jpeg?_gl=1*up7phr*_ga*MTEwNzAyNjQ3LjE3NzE0MDQ5OTY.*_ga_8JE65Q40S6*czE3NzE0OTEwMjckbzMkZzEkdDE3NzE0OTIxNTUkajQ5JGwwJGgw',
      span: 'col-span-1 row-span-2',
    },
    {
      id: 3,
      title: 'Kitchens',
      image: 'https://images.pexels.com/photos/10099319/pexels-photo-10099319.jpeg?_gl=1*5l1c9b*_ga*MTEwNzAyNjQ3LjE3NzE0MDQ5OTY.*_ga_8JE65Q40S6*czE3NzE0OTEwMjckbzMkZzEkdDE3NzE0OTI1MTckajIzJGwwJGgw',
      span: 'col-span-1 row-span-1',
    },
    {
      id: 4,
      title: 'Commercial',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=600&auto=format&fit=crop',
      span: 'col-span-2 row-span-1 md:col-span-1',
    },
    {
      id: 5,
      title: 'Outdoor Spaces',
      image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?q=80&w=600&auto=format&fit=crop',
      span: 'col-span-1 row-span-1',
    },
    {
      id: 6,
      title: 'Office Interiors',
      image: 'https://images.unsplash.com/photo-1604328698692-f76ea9498e76?q=80&w=600&auto=format&fit=crop',
      span: 'col-span-1 row-span-1',
    },
  ];

  return (
    <section
      id="inspiration"
      ref={sectionRef}
      data-testid="inspiration-section"
      className="py-24 md:py-32 bg-sand/30"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        {/* Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <span className="text-xs uppercase tracking-[0.2em] text-burgundy font-medium">
            Gallery
          </span>
          <h2
            data-testid="inspiration-heading"
            className="font-playfair text-3xl md:text-4xl lg:text-5xl text-matte-charcoal mt-4"
          >
            Design Inspiration
          </h2>
          <p className="mt-4 text-stone-grey max-w-xl mx-auto">
            Discover how our premium tiles transform spaces into timeless works of art
          </p>
        </motion.div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 auto-rows-[200px] md:auto-rows-[250px]">
          {inspirations.map((item, index) => (
            <motion.div
              key={item.id}
              data-testid={`inspiration-item-${item.id}`}
              className={`group relative overflow-hidden cursor-pointer ${item.span}`}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-matte-charcoal/0 group-hover:bg-matte-charcoal/40 transition-all duration-300" />
              
              {/* Title */}
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="font-playfair text-lg md:text-xl text-white">
                  {item.title}
                </h3>
              </div>

              {/* Corner Accent */}
              <div className="absolute top-4 right-4 w-8 h-8 border-t border-r border-white/0 group-hover:border-white/50 transition-colors duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Inspiration;
